import { ButtonPrimary, ButtonSecondary } from "components/Atoms/Button";
import React from "react";

interface Props {
  onCreateNewRowSelected: () => void
  onCopyFromShowSelected: () => void
}

const Choose = (props: Props) => {
  return (<div className="flex-column gap-small">
    <ButtonPrimary
      onClick={props.onCreateNewRowSelected}
      label={RESX.Timetable.AddItem}
    />
    <ButtonSecondary
      onClick={props.onCopyFromShowSelected}
      label={RESX.Timetable.FromOtherShow}
    />
  </div>
  );
};

export default Choose;
